import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useFormikContext } from "formik";
import { useLocation } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { baseURL } from "../../config";

const AwardTemplateForm = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [showToast, setShowToast] = useState(false);

  const nominationid = searchParams.get("awid");

  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [ratings, setRatings] = useState({
    personality_questions: [],
    job_questions: [],
    disciplinary_questions: [],
  });
  const [teamMembers, setTeamMembers] = useState([]);
  const [awardDatavalues, setAwardDataValues] = useState([]);

  const [month, setMonth] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        let response = [];
        let template = [];
        let jsontemplate = [];
        if (nominationid != null) {
          response = await axios.get(
            `${baseURL}/getAwardNomination?nid=` + nominationid
          );
          template = response.data.template[0];
          setAwardDataValues(template);
          jsontemplate = JSON.parse(template.question_answers);
          setCurrentTemplate(jsontemplate);
        } else {
          response = await axios.get(`${baseURL}/getAwardTemplate`);
          template = response.data.template[0];
          jsontemplate = JSON.parse(template.questionsjson);
          setCurrentTemplate(jsontemplate);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };

    fetchTemplate();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const id = localStorage.getItem("employeeid");
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + id
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchData();
  }, []);

  const handleRatingChange = (category, index, value, questionText) => {
    const newRatings = { ...ratings };
    newRatings[category][index] = { text: questionText, rating: value }; // Store both question text and rating
    setRatings(newRatings);
  };

  const calculateTotalRating = () => {
    let total = 0;
    for (const category in ratings) {
      total += ratings[category].reduce(
        (acc, rating) => acc + getRatingScore(rating),
        0
      );
    }
    return total;
  };

  const getRatingScore = (rating) => {
    switch (rating) {
      case "A":
        return 4;
      case "B":
        return 3;
      case "C":
        return 2;
      case "D":
        return 1;
      default:
        return 0;
    }
  };

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async (values) => {
    try {
      let id = localStorage.getItem("employeeid");
      const formData2 = {
        employeeid: formData.assignees, // Assuming assignees is an array of objects with 'value' property
        recommended_by: id, // Replace with actual value
        question_answers: {
          personality_questions: ratings.personality_questions,
          job_questions: ratings.job_questions,
          disciplinary_questions: ratings.disciplinary_questions,
        },
        month_year: month, // Replace with actual value
        justification: formData.justificationtxt,
        recommendation: formData.recommendationtxt,
        overallrating: formData.overallrating,
      };
      // Convert form values to JSON
      const formDataJSON = JSON.stringify(formData2);

      // Perform form submission with the JSON data
      const response = await axios.post(
        `${baseURL}/addemployeeofthemonth`,
        formDataJSON,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status >= 200) {
        // Reset form data and close modal after successful submission
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          window.location.href = "/awardsform";
        }, 3000);
      } else {
        // Handle the case where the form submission fails
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  if (!currentTemplate) {
    return <div>Loading...</div>;
  }

  const generateMonthYearOptions = () => {
    const options = [];
    const currentDate = new Date();
    const currentYear = parseInt(currentDate.getFullYear());
    const currentMonth = currentDate.getMonth();

    // Calculate the starting month index
    let startMonth = currentMonth - 1;
    let startYear = currentYear;

    // If the current month is January, adjust the starting month and year
    if (startMonth === -1) {
      startMonth = 11; // December
      startYear -= 1; // Previous year
    }

    // Loop through the next 12 months
    for (let i = 0; i < 12; i++) {
      const monthIndex = (startMonth + i) % 12;
      const year = startYear + Math.floor((startMonth + i) / 12);
      const date = new Date(year, monthIndex);
      const monthName = date.toLocaleString("default", { month: "short" });
      const yearMonth = `${monthName}-${year}`;
      options.push({
        value: yearMonth,
        label: yearMonth,
      });
    }
    return options;
  };

  const handleChangeMonth = (selectedOption) => {
    setMonth(selectedOption.value);
  };

  return (
    <>
      <Formik
        initialValues={{
          assignees: "",
          justificationtxt: "",
          recommendationtxt: "",
          overallrating: "",
          month_year: "",
        }}
        // validationSchema={Yup.object({
        //     title: Yup.string().required("Title is required"),
        //     description: Yup.string().required("Description is required"),
        // })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form>
            <h4>Employee Of the Month Nomination:</h4>
            <div className="d-flex">
              <div className="col-lg-5 mt-2">
                <label>
                  Assignee : {awardDatavalues.employee_firstname}{" "}
                  {awardDatavalues.employee_lastname}
                </label>
                <br />
                {awardDatavalues &&
                awardDatavalues.employee_firstname ? null : (
                  <Select
                    className=""
                    name="assignees"
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions.value;
                      setFieldValue("assignees", selectedValues);
                    }}
                    options={teamMembers.map((member, index) => ({
                      value: member.employeeid,
                      label: member.FirstName,
                    }))}
                    getOptionLabel={(option) =>
                      `${option.label} - ${option.value}`
                    }
                    isMulti={false}
                  />
                )}
              </div>
              <div className="col-lg-5 mt-2 ml-5">
                <label>Month : {awardDatavalues.month_year}</label>
                <br />
                {awardDatavalues && awardDatavalues.month_year ? null : (
                  <Select
                    name="month_year"
                    options={generateMonthYearOptions()}
                    value={{
                      value: values.month_year || month,
                      label: values.month_year || month,
                    }}
                    isMulti={false}
                    onChange={(selectedOption) => {
                      const selectedValue = selectedOption.value;
                      setFieldValue("month_year", selectedValue);
                      setMonth(selectedValue);
                    }}
                  />
                )}
              </div>
            </div>
            <h5 className="pt-3 mt-2">Personality Questions</h5>
            <table className="w-100">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.personality_questions.map(
                    (question, index) => (
                      <tr key={index}>
                        <td className="w-50">
                          <label>{question.text}</label>
                        </td>
                        <td className="p-2">
                          <select
                            className="w-75 m-1 p-1  float-end"
                            value={
                              (ratings &&
                                ratings.personality_questions[index]?.rating) ||
                              question.rating
                            }
                            onChange={(e) =>
                              handleRatingChange(
                                "personality_questions",
                                index,
                                e.target.value,
                                question.text
                              )
                            }
                            disabled={
                              awardDatavalues && awardDatavalues.month_year
                                ? true
                                : false
                            }
                          >
                            <option value="">Select</option>
                            <option value="A">A - Excellent</option>
                            <option value="B">B - Good</option>
                            <option value="C">C - Fair</option>
                            <option value="D">D - Poor</option>
                          </select>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
            <h5 className="pt-3 mt-2">Job Related Questions</h5>
            <table className="w-100 pt-3">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.job_questions.map((question, index) => (
                    <tr key={index}>
                      <td className="w-50">
                        <label>{question.text}</label>
                      </td>
                      <td className="p-2 w-75">
                        <select
                          className="w-75 m-1 p-1  float-end"
                          value={
                            ratings.job_questions[index]?.rating ||
                            question.rating
                          }
                          onChange={(e) =>
                            handleRatingChange(
                              "job_questions",
                              index,
                              e.target.value,
                              question.text
                            )
                          } // Pass question text
                          disabled={
                            awardDatavalues && awardDatavalues.month_year
                              ? true
                              : false
                          }
                        >
                          <option value="">Select</option>
                          <option value="A">A - Excellent</option>
                          <option value="B">B - Good</option>
                          <option value="C">C - Fair</option>
                          <option value="D">D - Poor</option>
                        </select>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {currentTemplate.disciplinary_questions ? (
              <h5 className="pt-3 mt-2">Disciplinary Questions</h5>
            ) : null}
            <table className="w-100 pt-3">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.disciplinary_questions &&
                  currentTemplate.disciplinary_questions.map(
                    (question, index) => (
                      <tr key={index}>
                        <td className="w-50">
                          <label>{question.text}</label>
                        </td>
                        <td className="p-2">
                          <select
                            className="w-75 m-1 p-1  float-end"
                            value={
                              (ratings &&
                                ratings.disciplinary_questions[index]
                                  ?.rating) ||
                              question.rating
                            }
                            onChange={(e) =>
                              handleRatingChange(
                                "disciplinary_questions",
                                index,
                                e.target.value,
                                question.text
                              )
                            }
                            disabled={
                              awardDatavalues && awardDatavalues.month_year
                                ? true
                                : false
                            }
                          >
                            <option value="">Select</option>
                            <option value="A">A - Excellent</option>
                            <option value="B">B - Good</option>
                            <option value="C">C - Fair</option>
                            <option value="D">D - Poor</option>
                          </select>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
            <div className="d-flex pt-3 mt-3 p-2">
              <div className="col-lg-6">
                <label>Justification</label>
                <br></br>
                <textarea
                  name="justificationtxt"
                  rows="5"
                  cols="40"
                  value={
                    values.justificationtxt || awardDatavalues.justification
                  }
                  onChange={handleChange}
                  disabled={awardDatavalues.justification}
                ></textarea>
              </div>
              <div className="col-lg-6 ml-3">
                <label>Recommendation</label>
                <br></br>
                <textarea
                  className="w-100"
                  rows="5"
                  cols="40"
                  name="recommendationtxt"
                  value={
                    values.recommendationtxt || awardDatavalues.recommendation
                  }
                  onChange={handleChange}
                  disabled={awardDatavalues.recommendation}
                ></textarea>
              </div>
            </div>
            <div className="col-lg-5 mt-3">
              <label>Overall Rating</label>
              <br></br>
              <select
                name="overallrating"
                className="w-75 m-1 p-1"
                value={values.overallrating || awardDatavalues.overallrating}
                onChange={handleChange}
                disabled={awardDatavalues.overallrating}
              >
                <option value="">Select</option>
                <option value="A">A - Excellent</option>
                <option value="B">B - Good</option>
                <option value="C">C - Fair</option>
                <option value="D">D - Poor</option>
              </select>
            </div>

            <div className="col-lg-11 text-end mt-4 pb-3">
              {awardDatavalues && awardDatavalues.month_year ? (
                <Button
                  className="border-0 mt-2 p-1 btn-#8d3523 savebtn w-25"
                  type="button"
                  onClick={() => (window.location.href = "/eomlist")}
                >
                  Go Back to List
                </Button>
              ) : (
                <>
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    type="button"
                    className="btn cancelbtn ml-2"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </Form>
        )}
      </Formik>
      <ToastContainer position="bottom-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          className="bg-success text-white"
        >
          <Toast.Header>
            <span className="me-2">✔️</span> {/* Unicode tick mark */}
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>Success!, data updated successfully!</Toast.Body>
        </Toast>
      </ToastContainer>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you Confirm this Changes</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AwardTemplateForm;
